function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m11.3333333 0c-6.25599997 0-11.3333333 5.07733333-11.3333333 11.3333333 0 6.256 5.07733333 11.3333334 11.3333333 11.3333334 6.256 0 11.3333334-5.0773334 11.3333334-11.3333334 0-6.25599997-5.0773334-11.3333333-11.3333334-11.3333333zm1.1333334 19.2666667h-2.2666667v-2.2666667h2.2666667zm2.346-8.7833334-1.02 1.0426667c-.816.8273333-1.326 1.5073333-1.326 3.2073333h-2.2666667v-.5666666c0-1.2466667.51-2.38 1.326-3.2073334l1.4053333-1.42799997c.4193334-.408.6686667-.97466666.6686667-1.598 0-1.24666666-1.02-2.26666666-2.2666667-2.26666666-1.2466666 0-2.26666663 1.02-2.26666663 2.26666666h-2.26666667c0-2.50466666 2.02866667-4.53333333 4.5333333-4.53333333 2.5046667 0 4.5333334 2.02866667 4.5333334 4.53333333 0 .99733334-.408 1.904-1.054 2.54999997z",
  fill: "#d0021b"
});

var SvgReasonBig = function SvgReasonBig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 23,
    viewBox: "0 0 23 23",
    width: 23,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReasonBig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reason_big.f69154bd.svg";
export { ForwardRef as ReactComponent };